import actionPanelStyles from './actionPanelStyles';

const condensedOrgContentChooserStyles = (theme) => ({
  ...actionPanelStyles(theme),
  orgContentChooser_columnHolder: {
    // copied from divCenterColumn
    // the next two are shared with divLeftColumn and divRightColumn
    display: 'flex',
    flexFlow: 'column nowrap',

    height: 'calc(100vh - 182px)',
    overflow: 'hidden',
  },
});

export default condensedOrgContentChooserStyles;
